import { VirtualFrequencyValue } from "./VirtualFrequencyControl.types";

export function getFrequencyName(dateRange: VirtualFrequencyValue) {
  switch (dateRange) {
    case VirtualFrequencyValue.Annual:
      return "Annual";
    case VirtualFrequencyValue.Quarter:
      return "Quarter";
    case VirtualFrequencyValue.Month:
      return "Month";
    case VirtualFrequencyValue.Week:
      return "Week";
    case VirtualFrequencyValue.Day:
      return "Day";
    default:
      throw new Error("No name given for date range");
  }
}
